import { setTrackingId } from "client/Misc/utils";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./BulletList.module.less";
import classNames from "classnames";

export type BulletListProps = {
	trackingId: string;
	rowGap?: "no-gap" | "large";
};

export const BulletList = (props: PropsWithChildren<BulletListProps>): ReactElement => {
	const {
		trackingId,
		rowGap = "no-gap",
		children
	} = props;

	return (
		<ul
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				{ [styles.root_largeRowGap]: rowGap === "large" }
			)}
		>
			{children}
		</ul>
	);
};
BulletList.displayName = "BulletList";

const BulletListItem = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<li>{children}</li>
	);
};
BulletListItem.displayName = "BulletList.Item";

BulletList.Item = BulletListItem;
